module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_j_albino.64c23190.png";